
import ConfigManager from '@/config/ConfigManager.js';

let BBEnumNotification = {
    Ads: "ads",
    Badge: "badge",
    Campaign: "campaign",
    Cat: "cat",
    Comment: "comment",
    Content: "content",
    Event: "event",
    Link: "link",
    Media: "media",
    Message: "message",
}

export default function NotificationModel (dict) {
    this.createTime = dict.CreateTime;
    this.isRead = dict.IsRead;
    this.objectCategory = dict.ObjectCategory;
    this.objectType = dict.ObjectType;
    this.partitionKey = dict.PartitionKey;
    this.rowKey = dict.RowKey;
    this.timestamp = dict.Timestamp;

    this.isShowIconApp = false;
    if(dict.Object) {
        this.categoryId = dict.Object.CategoryId ? dict.Object.CategoryId : null;
        this.id = dict.Object.ID ? dict.Object.ID : null;
        this.type = dict.Object.Type ? dict.Object.Type : null;
        this.fullImageUrl = dict.Object.FullImageUrl ? dict.Object.FullImageUrl : null;
        this.message = dict.Object.message ? dict.Object.message : null;

        if(this.objectType == BBEnumNotification.Ads)
        {
            this.message = dict.Object.Name;
        }
        else if(this.objectType == BBEnumNotification.Badge)
        {
            this.id = dict.Object.id;
            this.name = dict.Object.name;
            this.message = dict.Object.description;
            this.fb_message = dict.Object.fb_description;
            this.point = dict.Object.points;
            this.fullImageUrl = ConfigManager.getApiUrl() + "/badge/" + this.id + "/picture";
        }
        else if(this.objectType == BBEnumNotification.Campaign)
        {
            this.message = dict.Object.Name;
            this.agencyId = dict.Object.AgencyId;
            this.agencyLogo = dict.Object.AgencyLogo;
            this.agencyName = dict.Object.AgencyName;
        }
        else if(this.objectType == BBEnumNotification.Cat)
        {
            this.agencyId = dict.Object.AgencyId;
            this.message = dict.Object.Name;
            this.fullImageUrl = dict.Object.AgencyLogo;
        }
        else if(this.objectType == BBEnumNotification.Comment)
        {
            this.buzzKey = dict.Object.BuzzKey;
            this.fullImageUrl = ConfigManager.getApiUrl() + "/profile/" + dict.Object.UserId + "/picture";

            if(this.buzzKey.indexOf("fl-") >= 0) {
                this.isShowIconApp = true;
            }
        }
        else if(this.objectType == BBEnumNotification.Content)
        {
            this.count = dict.Object.Count;
            this.fullImageUrl = dict.Object.ImageUrl;
            this.categoryId = dict.Object.CategoryId;
        }
        else if(this.objectType == BBEnumNotification.Event)
        {
            this.message = dict.Object.Name;
        }
        else if(this.objectType == BBEnumNotification.Link)
        {
            this.url = dict.Object.url;
            this.isShowIconApp = true;
        }
        else if(this.objectType == BBEnumNotification.Media)
        {
            this.message = dict.Object.Name;
        }
        else if(this.objectType == BBEnumNotification.Message)
        {
            this.isShowIconApp = true;
        }
    }
}
